function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { DataTestIds } from 'src/config/dataTestIds';
import * as S from './Card.styles';
export const Card = ({
  children,
  onClick,
  className,
  onClose,
  Title,
  Extra,
  dataTestId,
  headerStyles,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(S.Root, _extends({
    className: className,
    onClick: onClick,
    "data-testid": dataTestId
  }, rest), /*#__PURE__*/React.createElement(S.Wrapper, null, /*#__PURE__*/React.createElement(S.Header, {
    headerStyles: headerStyles
  }, Title), onClose && /*#__PURE__*/React.createElement(S.CloseButton, {
    onClick: onClose,
    "data-testid": DataTestIds.DismissButton
  }), Extra && Extra), children);
};